import useTranslation from 'next-translate/useTranslation';
import { Title } from '../Services/Title';

interface WorkSectionProps {
  sellText: string;
  buyText: string;
}

interface BlockProps {
  text: string;
  borderClass: string;
}

function Block({ text, borderClass }: BlockProps) {
  return (
    <div className='col-span-3 flex gap-7'>
      <div className={`border-l-4 pl-4 text-black ${borderClass}`}>{text}</div>
    </div>
  );
}

function WorkSection({ sellText, buyText }: WorkSectionProps) {
  const { t } = useTranslation('services');

  return (
    <div className='space-y-8'>
      <Title title={t('services:How Does It Work?')} />
      <div className='grid grid-cols-4 gap-8'>
        <div className='text-md font-semibold text-black'>
          {t('services:Selling Process')}
        </div>
        <Block text={sellText} borderClass='border-orange-400' />
        <div className='text-md font-semibold text-black'>
          {t('services:Buying Process')}
        </div>
        <Block text={buyText} borderClass='border-slate-900' />
      </div>
    </div>
  );
}

export default WorkSection;
